import constants from "../constants";

const { SETTINGS_SAVE_DATA } = constants;

const initialState = {};
export default (state = initialState, action) => {
  if (!action) return state;
  const { type, data } = action;
  switch (type) {
    case SETTINGS_SAVE_DATA:
      return {
        ...data,
      };
    default:
      return state;
  }
};
